import clsx from "clsx";
import translate from "../../locales";

export function TextLabel({ center, for: id = "", label = "", children }) {
  const translated = label ? translate(label) : "";
  if (!translated && !children) {
    return null;
  }

  return (
    <label
      className={clsx(
        "input-group__label",
        center && "input-group__label_center",
      )}
      htmlFor={id}
    >
      {translated || children}
    </label>
  );
}
